import React, { useMemo, useState, useEffect } from 'react';
import { Tooltip } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/HelpOutlineOutlined';
import ReactHighcharts from 'react-highcharts';
import Highcharts from 'highcharts';

const utils = require('../../components/utils');
const SOURCE = '';
const LOADING = 'Loading...';
const CPM_COLOR = '#f02d5b';
const BORDER_COLOR = '#666666';

const RevenueEfficiencyComponent = ({authProvider, loading, pubBrRpm, profit, params, setPubBrRpmData, ...props}) => {
    const baseUrl = `${window.nobid_endpoint}/pubreports_br_rpm_base`;  
    const [panelMedian, setPanelMedian] = useState(0)
    const [panelMean, setPanelMean] = useState(0)
    // const [min, setMin] = useState(0)
    // const [max, setMax] = useState(0)
  
    const localConfig = useMemo(() => ({
      chart: {
        renderTo: 'container',
        zoomType: 'x',
        backgroundColor: 'none',
        borderColor: BORDER_COLOR,
        borderWidth: 1,
      },
      title: {
        text: 'REVENUE PER MILLION BID REQUESTS',
        style: { color: '#ffffff', fontSize: '12px', fontWeight: 600 }
      },
      subtitle: { text: loading ? LOADING : SOURCE },
      xAxis: {
        type: 'datetime',
        labels: {
          format: '{value:%e-%b}',
          style: { color: '#ffffff', fontFamily: 'Roboto, Helvetica, Arial, sans-serif', fontSize: '11px', fontWeight: 600 }
        },
        crosshair: true,
        gridLineWidth: 0,
      },
      yAxis: [{
        labels: { format: '${value}', style: { color: '#ffffff' } },
        title: { text: '$RPM-BR', style: { color: '#ffffff' } },
        gridLineWidth: 0,
        min: 0
      }
      ],
      plotOptions: {
        series: {
          marker: { enabled: true },
        }
      },
      series: [
        {
          name: '$RPM-BR',
          shadow: true,
          color: CPM_COLOR,
          borderColor: CPM_COLOR,
          type: 'line',
          borderRadius: 0,
          animation: Highcharts.svg,
          yAxis: 0,
          data: loading ? [] : pubBrRpm,
        },
        {
          name: 'Median RPM-BR',
          shadow: true,
          type: 'line',
          color: 'yellow',
          animation: Highcharts.svg,
          yAxis: 0,
          enableMouseTracking: false,
          dashStyle: 'ShortDash',
          data: loading || pubBrRpm.length<=0 ? [] : [ {x: pubBrRpm[0].x, y: panelMedian}, { x: pubBrRpm[pubBrRpm.length -1].x, y: panelMedian, dataLabels:{ 
          	enabled: true,
            format: `Panel Median RPM-BR ($${panelMedian?.toFixed(2)})`,
            color: '#ffffff',
            style: { textOutline: 'none' }
          } } ],
        },
        // {
        //   name: `Mean RPM-BR`,
        //   shadow: true,
        //   color: 'white',
        //   type: 'line',
        //   animation: Highcharts.svg,
        //   yAxis: 0,
        //   dashStyle: 'ShortDash',
        //   enableMouseTracking: false,
        //   data: loading ? [] : [ {x: pubBrRpm[0].x, y: panelMean}, { x: pubBrRpm[pubBrRpm.length -1].x, y: panelMean, dataLabels:{ 
        //   	enabled: true,
        //     format: `Panel Mean RPM-BR (${panelMean?.toFixed(2)}%)`,
        //     borderColor: false,
        //     color: '#ffffff',
        //     style: { textOutline: 'none' }
        //   } } ]
        // }
      ],
      legend: { 
        enabled: false,
        itemStyle: { color: '#ffffff' }
      },
      credits: { enabled: false }
    }), [pubBrRpm, panelMean, panelMedian, loading]);
  
    useEffect(()=>{
      let url = `${baseUrl}?${params.join('&')}`;
      let options = { headers: new Headers() };
      options.headers.set('accept', 'application/json');
      const token = localStorage.getItem('token');
      options.headers.set('Authorization', `Bearer ${token}`);
      fetch(url, options).then((response) => {
        localConfig.subtitle.text = SOURCE;
        return response.json();
      }).then((results) => {
        setPubBrRpmData(results[0])
        if (results?.length>0) {
          setPanelMedian(Number(results[0].median_br_rpm));
          setPanelMean(Number(results[0].mean_br_rpm));
        }
        // setMin(Number(results[0].min_br_rpm));
        // setMax(Number(results[0].max_br_rpm));
      });
    }, [pubBrRpm]);
  
    return (
      <div style={{position: 'relative'}}>
        <Tooltip title={
          <React.Fragment>
            Revenue per million bid requests and Panel Median
          </React.Fragment>
        } style={{position: 'absolute', right: 0, margin: '10px', zIndex: 1}}>
          <HelpIcon/>
        </Tooltip>
        <ReactHighcharts  isPureConfig={true} config={localConfig} />
      </div>
    )
}

export default RevenueEfficiencyComponent